import { BackOfficeCashFlowSummaryInstallation } from "@/model/data/branchReport/BackOfficeCashFlowSummaryInstallation";
import { FrontOfficeCashFlowSummaryInstallation } from "@/model/data/branchReport/FrontOfficeCashFlowSummaryInstallation";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetBranchReportResData extends ServiceResponseData {
    /** Lista di installazioni con le informazioni necessarie per visualizzare il branch report */
    frontOfficeCashFlowSummaryInstallations: FrontOfficeCashFlowSummaryInstallation[];
    backOfficeCashFlowSummaryInstallations: BackOfficeCashFlowSummaryInstallation[];

    constructor(response: AxiosResponse) {
        super(response);
        this.frontOfficeCashFlowSummaryInstallations = [];
        this.backOfficeCashFlowSummaryInstallations = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.FrontOfficeCashFlowSummaryInstallations && obj.FrontOfficeCashFlowSummaryInstallations.length > 0) {
            obj.FrontOfficeCashFlowSummaryInstallations.forEach((e) => {
                var inst = new FrontOfficeCashFlowSummaryInstallation();
                inst.parse(e);
                this.frontOfficeCashFlowSummaryInstallations.push(inst);
            });
        }
        if (obj.BackOfficeCashFlowSummaryInstallations && obj.BackOfficeCashFlowSummaryInstallations.length > 0) {
            obj.BackOfficeCashFlowSummaryInstallations.forEach((e) => {
                var inst = new BackOfficeCashFlowSummaryInstallation();
                inst.parse(e);
                this.backOfficeCashFlowSummaryInstallations.push(inst);
            });
        }
    }
}
